export function getQueryVariable(url, variable) {
    if (!url || url.indexOf('?') === -1) {
        return false
    }
    let urlSplit = url.split('?')
    let query = urlSplit[1]
    let vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1])
        }
    }
    return false
}

export function clone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export function isLocalTokenValid() {
    // TODO: add expire time check
    return !!localStorage.getItem('user_token')
}

export function getOS() {
    let userAgent = window.navigator.userAgent
    let platform = window.navigator.platform
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
    } else if (/Android/.test(userAgent)) {
        os = 'Android'
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
    }

    return os
}

export function pad(num, size) {
    var s = num + ''
    while (s.length < size) s = '0' + s
    return s
}

export function mmssToSeconds(mmss) {
    if (!mmss) return 0
    let mmssSplit = mmss.split(':')
    if (mmssSplit.length !== 2) return false
    let mm = parseInt(mmssSplit[0])
    let ss = parseFloat(mmssSplit[1])
    return mm * 60 + ss
}

export function secondsToMMSS(sec, fractionDigits = 0) {
    if (!sec) return '00:00'
    if (fractionDigits < 0) fractionDigits = 0
    let mm = Math.floor(sec / 60)
    let ss = sec % 60
    let pn = fractionDigits === 0 ? 2 : fractionDigits + 2
    return pad(mm.toFixed(0), pn) + ':' + pad(ss.toFixed(fractionDigits), pn)
}

export function secondsToHHMMSS(sec, fractionDigits = 0) {
    if (!sec) return '00:00:00'
    if (fractionDigits < 0) fractionDigits = 0
    let hh = Math.floor(sec / 3600)
    let mm = Math.floor((sec % 3600) / 60)
    let ss = sec % 60
    let pn = fractionDigits === 0 ? 2 : fractionDigits + 2
    return pad(hh.toFixed(0), pn) + ':' + pad(mm.toFixed(0), pn) + ':' + pad(ss.toFixed(fractionDigits), pn)
}

export function parseYoutubeVideoID(url, type) {
    if (!url) return false
    if (!type) {
        type = 'video'
    }
    if (url.indexOf('youtube.com/') >= 0) {
        if (url.indexOf('list=') >= 0) {
            return getQueryVariable(url, 'list')
        } else {
            if (type === 'tvseries') {
                return false
            }
            return getQueryVariable(url, 'v')
        }
    } else if (url.indexOf('youtu.be/') >= 0) {
        let listId = getQueryVariable(url, 'list')
        if (listId) {
            return listId
        } else {
            let startIndex = url.indexOf('youtu.be/') + 'youtu.be/'.length
            return url.substring(startIndex)
        }
    }
}

export function parseYoukuVideoID(url, type) {
    if (!url) return false
    if (!type) {
        type = 'video'
    }

    if (url.indexOf('v_show') >= 0) {
        let startIndex = url.indexOf('id_') + 'id_'.length
        let endIndex = url.indexOf('.html?')
        let videoId = url.substring(startIndex, endIndex)
        return videoId
    } else {
        return false
    }
}

export function parseBilibiliVideoID(url, type) {
    if (!url) return false
    if (url.indexOf('bangumi/') >= 0) {
        return false
    } else if (url.indexOf('video/') >= 0) {
        let startIndex = url.indexOf('video/') + 'video/'.length
        let endIndex = url.indexOf('?')
        if (endIndex >= 0) {
            return url.substring(startIndex, endIndex)
        } else {
            return url.substring(startIndex)
        }
    }
}

export function parseTencentVideoId(url, type) {
    if (!url) return false
    if (url.indexOf('x/cover/') >= 0) {
        let startIndex = url.indexOf('cover/') + 'cover/'.length
        let endIndex = url.indexOf('.html')
        let id = url.substring(startIndex, endIndex)
        if (id.indexOf('/') >= 0) {
            id = id.substring(0, id.indexOf('/'))
        }
        return id
    } else if (url.indexOf('x/page/') >= 0) {
        let startIndex = url.indexOf('page/') + 'page/'.length
        let endIndex = url.indexOf('.html')
        let id = url.substring(startIndex, endIndex)
        return id
    } else {
        return false
    }
}

export function displayBalance(petalAmount, precision = 0) {
    if (typeof petalAmount !== 'number') {
        petalAmount = Number.parseFloat(petalAmount)
    }
    if (petalAmount >= 1000000000) {
        return (petalAmount / 1000000000).toFixed(precision) + ' B'
    } else if (petalAmount >= 1000000) {
        return (petalAmount / 1000000).toFixed(precision) + ' M'
    } else if (petalAmount >= 1000) {
        return (petalAmount / 1000).toFixed(precision) + ' K'
    } else if (petalAmount > 1) {
        return petalAmount.toFixed(0) + ' Petals'
    } else {
        return petalAmount.toFixed(0) + ' Petal'
    }
}

export function parseVideoSrc(url) {
    if (!url) return false
    if (url.indexOf('youtube.com/') >= 0 || url.indexOf('youtu.be/') >= 0) {
        return 'youtube'
    } else if (url.indexOf('bilibili.com/') >= 0 || url.indexOf('b23.tv/') >= 0) {
        return 'bilibili'
    } else if (url.indexOf('v.qq.com/') >= 0) {
        return 'tencent'
    } else if (url.indexOf('subo988.com/') >= 0) {
        return 'subo'
    } else if (url.indexOf('zdziyuan.com/') >= 0) {
        return 'zdziyuan'
    } else {
        return false
    }
}

export function parseSuboVideoId(url, type) {
    if (!url) return false
    let a = 'm=vod-detail-id-'
    let left = url.indexOf(a) + a.length
    let right = url.indexOf('.html')
    let id = url.substring(left, right)
    return id
}

export function parseZdziyuanVideoId(url, type) {
    if (!url) return false
    let a = 'm=vod-detail-id-'
    let left = url.indexOf(a) + a.length
    let right = url.indexOf('.html')
    let id = url.substring(left, right)
    return id
}



// WEBPACK FOOTER //
// ./src/utils/common.js